import { Button, Toast as VoltToast } from "@volt_developers/components";
import { toast, ToastOptions } from "react-toastify";

import { useToast } from "../../hooks/toasts/useToast";

import type { ReactNode } from "react";
import type { ToastVariant } from "../../hooks/toasts/useToast";

export type ToastProps = SingleButtonToastProps & {
  config?: ToastOptions;
};

export interface SingleButtonToastProps {
  bodyContent: ReactNode;
  buttonText: ReactNode;
  handleClick: () => void;
  toastProps?: ToastOptions;
  variant: ToastVariant;
}

export function SingleButtonToast({
  bodyContent,
  buttonText,
  handleClick,
  toastProps,
  variant,
}: SingleButtonToastProps) {
  const { buttonVariant, buttonColor, iconComponent } = useToast(variant);

  return (
    <VoltToast
      data-testid={(toastProps?.toastId as string) ?? "toast"}
      variant={variant}
    >
      <VoltToast.RootWrapper>
        <VoltToast.IconWrapper>{iconComponent}</VoltToast.IconWrapper>
        <VoltToast.ContentWrapper>
          {bodyContent}
          <VoltToast.ContentFooter>
            <Button
              variant={buttonVariant}
              color={buttonColor}
              onClick={handleClick}
            >
              {buttonText}
            </Button>
          </VoltToast.ContentFooter>
        </VoltToast.ContentWrapper>
      </VoltToast.RootWrapper>
    </VoltToast>
  );
}

export const showSingleButtonToast = ({
  config,
  ...propsForToast
}: ToastProps) => toast(<SingleButtonToast {...propsForToast} />, config);
